// @ts-nocheck
/* eslint-disable */

import React from 'react';
import AddEntity from 'app/components/CRUD/AddEntity';

import {
  CONFIG_PATHS,
  CONFIG_ROUTES,
} from 'app/configuration/configuration-api';

/**
 * maxLength mirrors public.fare_media_type:
 *   en_name varchar(45) NOT NULL, UNIQUE
 *   ar_name varchar(45) NOT NULL, UNIQUE
 * Both names are also unique, so a clash comes back from the API as a
 * translated 409 rather than being caught here.
 */
const inputs = [
  {
    name: 'en_name',
    labelKey: 'NameEnglish',
    type: 'text',
    required: true,
    maxLength: 45,
    defaultValue: '',
  },
  {
    name: 'ar_name',
    labelKey: 'NameArabic',
    type: 'text',
    required: true,
    maxLength: 45,
    defaultValue: '',
  },
  {
    name: 'is_test',
    labelKey: 'IsTest',
    type: 'checkbox',
    defaultValue: false,
    hint: 'IsTestHint',
  },
  {
    name: 'is_old',
    labelKey: 'IsOld',
    type: 'checkbox',
    defaultValue: false,
    hint: 'IsOldHint',
  },
];

const AddFareMediaType: React.FC = () => {
  const buildSubmitPayload = formValues => ({
    en_name: formValues.en_name,
    ar_name: formValues.ar_name,
    // Coerced to real booleans — the checkbox leaves '' for "never touched",
    // and the API validates with isBoolean().
    is_test: !!formValues.is_test,
    is_old: !!formValues.is_old,
  });

  return (
    <AddEntity
      pageTitle="AddNewFareMediaType"
      backUrl={CONFIG_ROUTES.fareMediaTypes}
      submitApiUrl={CONFIG_PATHS.fareMediaTypes}
      inputs={inputs}
      dropdowns={[]}
      buildSubmitPayload={buildSubmitPayload}
      successMessage="FareMediaTypeCreatedSuccessfully"
      addButtonLabel="Add"
      subsystemName="FareMediaTypes"
      permissionSystem="masterConfig"
    />
  );
};

export default AddFareMediaType;
